module.exports = __webpack_public_path__ + "img/icon_place_white.132ff726.svg";